import React, {useState} from "react";
import BondNode from "components/BondTree/Node";
import CreateDeviceComponent from "./CreateDevice";
import Device from "./Device";
import ClearDevicesComponent from "./ClearDevices";
import ButtonGroup from 'react-bootstrap/ButtonGroup';

function DevicesComponent(props) {
    const [reloadTimestamp, setReloadTimestamp] = useState(null);

    function reload() {
        setReloadTimestamp(Date.now());
    }

    function customAttrComponent(attr, value) {
        if (attr === "__") return null;
        return (
            <Device
                key={attr}
                parentU={value["_"]}
                bond={props.bond}
                path={props.path + attr + "/"}
                label={attr}
                onDeviceDeleted={() => {
                    reload();
                }}
            />
        );
    }

    return (
        <BondNode
            {...props}
            reloadTimestamp={reloadTimestamp}
            customAttrComponent={customAttrComponent}
            extraComponentsStart={[
                <CreateDeviceComponent
                    key="createDevice"
                    bond={props.bond}
                    onDeviceCreated={() => {
                        reload();
                    }}
                />
            ]}
        />
    );
}

export default DevicesComponent;
